import React, {useState, useEffect, useRef} from "react";
import {DEFAULT_BLUE} from "../../../constants/general-constants";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {functions} from "../../../constants/common-functions";
import {STRINGIFY} from "../../../constants/general-constants";
import EditPanel from '../components/EditPanel';
import {INPUT_TYPE_TEXT} from "../../../constants/input-types";
import {INPUT_TYPE_TEXTAREA} from "../../../constants/input-types";
import EditButtonPanel from '../components/EditButtonPanel';
import AdminListPanelFloors from '../components/AdminListPanelFloors';
import {INPUT_TYPE_SELECTFROMDB} from "../../../constants/input-types";
import EditPanelInputSelect from '../components/EditPanelInputSelect';
import EditPanelInputText from '../components/EditPanelInputText';

export default function AdminFloors({buildingId, buildingName, isSite}){
	
	const [floors, setFloors] = useState([]);
	const [displayFloorList, setDisplayFloorList] = useState("none");
	const [displayFloorEdit, setDisplayFloorEdit] = useState("none");
	const [floorName, setFloorName] = useState("");
	const [floorId, setFloorId] = useState("-100");
	const [simpleResourceOptions, setSimpleResourceOptions] = useState([]);
	const [scanId, setScanId] = useState("-100");
	
	const refCode = useRef(null);
	const refName = useRef(null);
	const refDescription = useRef(null);
	const refCapacity = useRef(null);
	const refArea = useRef(null);
	const refFloorPlan = useRef(null);
	const refFloorOrdinal = useRef(null);
	
	const [displayFloorButton, setDisplayFloorButton] = useState("flex");
	
	const refAtisUrl = useRef(null);
	
	
	useEffect(() => {
		loadFloors();
		functions.getArrayFromAjax("/resolution/getsimpleresourcesforfacility?search=&facilityId=" + buildingId, null, populateSimpleResourceOptions);
	}, [buildingId]);
	
	useEffect(() => {
		loadFloor();
	}, [floorId]);
	
	useEffect(() => {
		if(isSite === false){
			setDisplayFloorButton("flex");
		}
		else{
			setDisplayFloorButton("none");
		}
	}, [isSite]);
	
	const getEntityCode = () => {
		return refCode.current.value;
	};
	
	const populateSimpleResourceOptions = (results) => {
		let tempSimpleResourceOptions = [];
		for(let i=0; i<results.length; i++){
			tempSimpleResourceOptions.push({
				value:results[i].id,
				text:results[i].title
			});
		}
		setSimpleResourceOptions(tempSimpleResourceOptions);
	};
	
	const getEntityName = () => {
		return refName.current.value;
	};
	
	const getSimpleResourcesUrl = () => {
		return "getsimpleresourcesforfacility?facilityId=" + buildingId;
	};
	
	const mainComponentRows = [
		{ref:refCode, id:"1", title:"Code", inputType:INPUT_TYPE_TEXT},
		{ref:refName, id:"2", title:"Name", inputType:INPUT_TYPE_TEXT},
		{ref:refDescription, id:"3", title:"Description", inputType:INPUT_TYPE_TEXTAREA},
		{ref:refArea, id:"4", title:"Area (Sq Ft)", inputType:INPUT_TYPE_TEXT},
		{ref:refCapacity, id:"5", title:"Capacity", inputType:INPUT_TYPE_TEXT},
		{ref:refFloorOrdinal, id:"6", title:"Floor Ordinal (Level)", inputType:INPUT_TYPE_TEXT}
	];
	
	const loadFloors = () => {
		functions.getArrayFromAjax("/resolution/facilitygetfloorlist?facilityId=" + buildingId, setFloors, null);
	};
	
	const loadFloor = () => {
		functions.getArrayFromAjax("/resolution/facilityspace?id=" + floorId, null, setFloorInfo);
		const timer = setTimeout(() => {
			functions.getObjectFromAjax("/resolution/facilityfloorscansforfloor?floorId=" + floorId, null, initialiseScan);
		}, 2000);
	};
	
	const initialiseScan = (scan) => {
			setScanId(scan.id);
			refFloorPlan.current.value = scan.simpleResourceId;
			refAtisUrl.current.value = scan.atisUrl
	};
	
	const resetFloor = () => {
		setFloorId("-100");
		refCode.current.value = "";
		refName.current.value = "";
		refDescription.current.value = "";
		refArea.current.value = "";
		refCapacity.current.value = "";
		refFloorOrdinal.current.value = "";
		setFloorName("")
	};
	
	const setFloorInfo = (floor) => {
		setFloorName(floor.name);
		refCode.current.value = floor.code;
		refName.current.value = floor.name;
		refDescription.current.value = floor.description;
		refArea.current.value = floor.area;
		refCapacity.current.value = floor.capacity;
		refFloorOrdinal.current.value = floor.floorOrdinal;
	};
	
	const thisContainer = {
		display:"flex",
		flexDirection:"column"
	};
	
	const floorButton = {
		display:displayFloorButton,
		width:"200px",
		height:"30px",
		color:"white",
		fontSize:"14px",
		alignItems:"center",
		justifyContent:"space-around",
		cursor:"pointer",
		borderRadius:"4px",
		backgroundColor:DEFAULT_BLUE,
		boxShadow:'0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.13)',
		margin:"10px",
		marginTop:"20px"
	};
	
	const showFloorList = () => {
		setDisplayFloorList("flex");
	};
	
	const floorList = {
		display:displayFloorList,
		position:"absolute",
		left:"70px",
		top:"70px",
		width:"calc(100% - 60px)",
		height:"100vh",
		flexDirection:"column",
		backgroundColor:"white",
		zIndex:"1000"
	};
	
	const administrationHeader = {
		display:"flex",
		height:"60px",
		paddingLeft:"30px",
		alignItems:"center",
		color:"black",
		justifyContent:"space-between",
		width:"calc(100% - 60px)"
	};
	
	const buttonContainer = {
		display:"flex"
	};
	
	const menuButton = {
		display:"flex",
		height:"30px",
		width:"150px",
		backgroundColor:DEFAULT_BLUE,
		alignItems:"center",
		justifyContent:"space-around",
		color:"white",
		fontSize:"14px",
		cursor:"pointer",
		boxShadow:'0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.13)',
		borderRadius:"4px",
		marginLeft:"5px"
	};
	
	const goClose = () => {
		setDisplayFloorList("none");
	};
	
	const goNew = () => {
		resetFloor();
		setDisplayFloorEdit("flex");
	};
	
	const goFloor = (id) => {
		setFloorId(id);
		setDisplayFloorEdit("flex");
	};
	
	const floorEditRowContainer = {
		display:"flex",
		width:"calc(100% - 90px)",
		flexDirection:"column",
		backgroundColor:"#eee",
		borderRadius:"4px",
		padding:"20px",
		marginLeft:"20px"
	};
	
	const floorRow = {
		display:"flex",
		width:"calc(100% - 40px)",
		backgroundColor:"white",
		borderBottom:"1px solid #eee",
		cursor:'pointer',
		alignItems:"center"
	};
	
	const floorIcon = {
		display:"flex",
		width:"20px",
		height:"20px",
		color:DEFAULT_BLUE,
		margin:"10px"
	};
	
	const floorNameContainer = {
		display:"flex",
		fontSize:"14px",
		color:'black'
	};
	
	const floorDisplay = floors.map((item, index) => 
		<div style={floorRow} onClick={() => {goFloor(item.id)}}>
				<FontAwesomeIcon icon="arrow-right" style={floorIcon}/>
				<div style={floorNameContainer}>
					{item.name}
				</div>
		</div>
	);
	
	const floorEdit = {
		display:displayFloorEdit,
		position:"absolute",
		left:"70px",
		top:"70px",
		width:"calc(100% - 60px)",
		height:"100vh",
		flexDirection:"column",
		backgroundColor:"white",
		zIndex:"1000"
	};
	
	const contentPanel = {
		display:"flex",
		width:"100%",
		alignItems:"top"
	};
	
	const contentPanelRight = {
		display:"flex",
		flexDirection:"column",
		width:"50%",
		alignItems:"top"
	};
	
	const otherContent = {
		display:"flex",
		width:"calc(100% - 40px)",
		backgroundColor:"#eee",
		borderRadius:"4px",
		flexDirection:"column",
		marginLeft:"30px",
		marginBottom:"30px"
	};
	
	const otherContentTitle = {
		display:"flex",
		width:"100%",
		height:"30px",
		alignItems:"center",
		fontSize:"14px",
		fontWeight:"bold",
		justifyContent:"space-around"
	};
	
	const editRow = {
		display:"flex",
		minHeight:"40px",
		alignItems:"center"
	};
	
	const editTitle = {
		display:"flex",
		width:"150px",
		fontSize:"12px",
		paddingLeft:"20px"
	};
	
	const getSubmitObject = () => {
		
		let submitObject = {
			id:floorId,
			parentId:-100,
			facilityId:buildingId,
			code:refCode.current.value,
			name:refName.current.value,
			description:refDescription.current.value,
			gpsCoords:"",
			photoFile:"",
			planFile:"",
			svgPath:"",
			capacity:refCapacity.current.value,
			area:refArea.current.value,
			costPerArea:0,
			costPerAreaCurrencyId:-100,
			archived:false,
			divisionOwnerId:-100,
			lat:"",
			lng:"",
			isFloor:true,
			facilitySpaceClassificationId:-100,
			unitAreaId:0,
			scanId:"",
			floorOrdinal:refFloorOrdinal.current.value
		};
		console.log(submitObject);
		return submitObject
	};
	
	const goSubmit = () => {
		
		functions.submitAjax("/resolution/facilityspacesave", 
				getSubmitObject(), saveScanInfo,  STRINGIFY, handleSubmitError);
		
	};
	
	const saveScanInfo = () => {
		
		let facilityFloorScan = {
			id:scanId,
			facilityId:buildingId,
			floorId:floorId,
			matterportScanId:'',
			truviewScanId:'',
			atisUrl:refAtisUrl.current.value,
			rvtFile:'',
			cintooId:'',
			giraffeId:'',
			simpleResourceId:refFloorPlan.current.value
		};
		
		functions.submitAjax("/resolution/facilityfloorscansave", 
				facilityFloorScan, saveEnd,  STRINGIFY, handleSubmitError);
	};
	
	const handleSubmitError = (e) => {
		console.log(e);
	};
	
	const saveEnd = () => {
		goCancel();
		loadFloors();
	};
	
	const goDelete = () => {
		functions.submitAjax("/resolution/facilityspacedelete", 
				getSubmitObject(), saveEnd,  STRINGIFY, handleSubmitError);
	};
	
	const goCancel = () => {
		setFloorId("-100");
		setDisplayFloorEdit("none");
	};
	
	
	return (
		<div style={thisContainer}>	
			<div style={floorButton} onClick={showFloorList}>
				Floors
			</div>
			<div style={floorList}>
				<div style={administrationHeader}>
					Floors For {buildingName}
					<div style={buttonContainer}>
						<div style={menuButton} onClick={goNew}>
							New Floor
						</div>
						<div style={menuButton} onClick={goClose}>
							Close
						</div>
					</div>
				</div>
				<div style={floorEditRowContainer}>
					{floorDisplay}
				</div>
			</div>
			
			<div style={floorEdit}>
				<div style={administrationHeader}>
					Floor Edit: {floorName}
				</div>
				<div style={contentPanel}>
					<EditPanel
					title="Main Details"
						componentRows = {mainComponentRows}
					/>
					<div style={contentPanelRight}>
						<div style={otherContent}>
							<div style={otherContentTitle}>
								Floor Plan & Scans
							</div>
							<div style={editRow}>
								<div style={editTitle}>
									Floor Plan
								</div>
								<EditPanelInputSelect thisRef={refFloorPlan} options={simpleResourceOptions}/>
							</div>
						
						<div style={editRow}>
							<div style={editTitle}>
								Scan Url (e.g. Attis)
							</div>
							<EditPanelInputText thisRef={refAtisUrl}/>
						</div>
					
						</div>
						<AdminListPanelFloors
							floorId={floorId}
							buildingId={buildingId}
						/>
					</div>
				</div>
				<EditButtonPanel
					id={floorId}
					goSubmit={goSubmit}
					goDelete={goDelete}
					goCancel={goCancel}
					checkCodeUrl="facilityspaces"
					getCodeFunction={getEntityCode}
					getNameFunction={getEntityName}
				/>
			</div>
			
		</div>
		
	);
}